var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentNewVersionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5 4.5c-.27614 0-.5.22386-.5.5s.22386.5.5.5h6c.27614 0 .5-.22386.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 7c0-.27614.22386-.5.5-.5h6c.27614 0 .5.22386.5.5s-.22386.5-.5.5h-6c-.27614 0-.5-.22386-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 8.5c-.27614 0-.5.22386-.5.5s.22386.5.5.5h6c.27614 0 .5-.22386.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 10.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h4c.27614 0 .5-.2239.5-.5s-.22386-.5-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 4c0-1.10457.89543-2 2-2h7c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-7c-1.10457 0-2-.8954-2-2zm9-1h-7c-.55228 0-1 .44772-1 1v10c0 .5523.44772 1 1 1h7c.5523 0 1-.4477 1-1v-10c0-.55228-.4477-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2c0-1.104569-.8954-2-2-2h-6.5v1h6.5c.5523 0 1 .44771 1 1v10h1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNewVersionIcon);
export default __webpack_public_path__ + "static/media/document-new-version-icon.8b7521ceba79923c24ba1b3c134ba9c4.svg";
export { ForwardRef as ReactComponent };